export default {
  /**
   *
   * @param state
   * @param property
   * @param payload
   */
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },
};
